import { render, staticRenderFns } from "./IntroMobil.vue?vue&type=template&id=491468f3&scoped=true&"
import script from "./IntroMobil.vue?vue&type=script&lang=js&"
export * from "./IntroMobil.vue?vue&type=script&lang=js&"
import style0 from "./IntroMobil.vue?vue&type=style&index=0&id=491468f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491468f3",
  null
  
)

component.options.__file = "IntroMobil.vue"
export default component.exports